<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>
    <div class="ViewDieselInfo ViewPromo__section">
      <div class="ViewDieselInfo__row">
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__content">
            <h2 class="ViewDieselInfo__title">{{ name }}</h2>
            <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
            <div class="ViewDieselInfo__text app-typography">
              <p>
                С 2018 года компания «РУС-НПЗ» является оптовым поставщиком
                нефтепродуктов и располагает обширной многоотраслевой клиентской
                базой с географией поставок по всей территории РФ.
              </p>
              <p>
                Компания ООО «РУС-НПЗ» является зарегистрированным участником
                торгов биржи СПБМТСБ в секции нефтепродукты и имеет прямые
                договора с крупнейшими российскими нефтяными компаниями ПАО
                «Газпром нефть», ПАО «Лукойл», ПАО «НК «Роснефть», ПАО
                «Татнефть», ПАО «Транснефть».
              </p>
              <p>
                Мы закупаем нефтепродукты крупным оптом по наиболее выгодным
                ценам напрямую у производителей, обеспечиваем авто и ЖД
                логистику, хранение бензинов, авиакеросинов, дизельных топлив,
                мазута, битума, СУГ и др. продукции нефтепереработки и
                нефтехимии для своих клиентов, гарантируя прозрачность,
                стабильность качества всей поставляемой продукции, оперативность
                поставок и выгодные цены.
              </p>
              <p>
                Клиентами ООО «РУС-НПЗ» являются, автопарки,
                дорожно-строительные компании, автозаправочные станции,
                бункерные и судоходные компании, лесозаготовительные
                нефтедобывающие и горнодобывающие предприятия, предприятия
                металлообработки и целлюлозно-бумажной отрасли и др. За
                многолетний опыт работы в своем портфеле мы имеем множество
                исполненных контрактов в рамках госзакупок по 44ФЗ и 223ФЗ
                различной сложности, в том числе на закрытые объекты, такие как
                АЭС, ЗАТО и удаленные труднодоступные районы крайнего севера.
              </p>
              <p>
                Нашей целью при заключении каждого нового договора являются
                долгосрочные отношения в качестве надёжного и ответственного
                партнёра. Компания «РУС-НПЗ» предлагает широкий выбор
                нефтепродуктов, которые соответствуют международным стандартам
                качества, имеют необходимые сертификаты соответствия и допуски к
                применению, высокое качество и конкурентоспособные цены.
              </p>
              <p>
                На сегодняшний день головной офис компании находится в Москве, и
                мы имеем собственное подразделение в г. Санкт-Петербург. В
                случае заинтересованности в взаимовыгодном сотрудничестве,
                просим направить в адрес ООО «РУС-НПЗ» для расчета стоимости
                нефтепродуктов техническое задание с количеством, наименованием
                товара и адресной картой поставок.
              </p>
              <p>
                Надеемся на дальнейшее плодотворное и взаимовыгодное
                сотрудничество.
              </p>
            </div>
          </div>
        </div>
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__advantages-wrapper">
            <ul class="ViewPromo__advantages">
              <li class="ViewPromo__advantage">
                <div class="ViewPromo__advantage-icon">
                  <app-svg-icon
                    name="iphone"
                    class="ViewPromo__advantage-icon-svg"
                  ></app-svg-icon>
                </div>
                <div class="ViewPromo__advantage-text">
                  <h4 class="ViewPromo__advantage-title">Данные поставщика</h4>
                  <p>
                    Телефон компании:<br />
                    <strong
                      ><a
                        href="tel:+74951090122"
                        class="ViewPromo__advantage-contact-link"
                        >+7 (495) 109-01-22</a
                      ></strong
                    >
                  </p>
                  <p>
                    Адрес электронной почты:<br />
                    <strong
                      ><a
                        href="mailto:info@rusnpz.ru"
                        class="ViewPromo__advantage-contact-link"
                        >info@rusnpz.ru</a
                      ></strong
                    >
                  </p>
                  <!-- <a
                      class="ViewPromo__advantage-link"
                      href="/static/uploads/docs/Cкачать_реквизиты_пром-ресурс.doc"
                      download="Реквизиты ПромРесурс.doc"
                      >Cкачать реквизиты ПромРесурс</a
                    > -->
                </div>
              </li>
              <!-- <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы отгрузки</h4>
                    <p>
                      ДТ Рузаевка; н/б Аэрофьюлз (Аэропорт г. Нижний
                      Новгород);<br />
                      Дельта Торг
                    </p>
                  </div>
                </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «РУС-НПЗ»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 883,
    productId: 2060,
    name: 'ООО «РУС-НПЗ»',
    inn: '7839101563',
  }),
};
</script>

<style lang="scss" scoped>
.ViewPromo__logo-img {
  height: rem(90);
}
</style>
